<app-header 
  (filterChange)="onCategoryFilterChange($event)"
  (brandFilterChange)="onBrandFilterChange($event)"
  (openFilterChange)="onOpenFilterChange($event)"
  (searchFilterChange)="onSearchFilterChange($event)"
  >
</app-header>
<div class="no-result-found-watermark">
  <img src="assets/img/no-result-watermark.png" alt="">
    <p>Your search resulted in no results. Try again with diffrent keywords.</p>
</div>
